import type { ReminderDraft, TaskReminder } from '../db/models'

/** Die Zeile zu einem Entwurf — dieselbe Form in Dexie und in der Speicher-Quelle. */
export function reminderFromDraft(taskId: string, draft: ReminderDraft, now: Date, id: string = crypto.randomUUID()): TaskReminder {
  return {
    id,
    taskId,
    kind: draft.kind,
    anchor: draft.kind === 'relative' ? draft.anchor : null,
    offsetMinutes: draft.kind === 'relative' ? draft.offsetMinutes : null,
    remindDate: draft.kind === 'absolute' ? draft.remindDate : null,
    remindTime: draft.kind === 'absolute' ? draft.remindTime : null,
    recurrence: draft.kind === 'absolute' ? draft.recurrence ?? null : null,
    snoozedUntil: null,
    importedFrom: draft.importedFrom ?? null,
    userId: null,
    cloudId: null,
    deletedAt: null,
    createdAt: now,
    updatedAt: now,
    lastModified: now,
    synced: false,
    syncedAt: null,
  }
}

/** Der Entwurf der **Standard-Erinnerung**: vor dem Wann, Vorlauf aus den Einstellungen. */
export const STANDARD_REMINDER: ReminderDraft = { kind: 'relative', anchor: 'start', offsetMinutes: null }

/**
 * **Bekommt die Aufgabe jetzt die Standard-Erinnerung?** Nur beim Übergang „keine Uhrzeit am
 * Wann → Uhrzeit“ — ein Zeitraum (Vormittag …) zählt nicht, sonst klingelte jede
 * Vormittags-Aufgabe um 7:30. Wer sie gelöscht hat und die Uhrzeit nur verschiebt, bekommt
 * keine neue (Todoist hatte genau diesen Fehler).
 */
export function gainsStartTime(before: { startTime?: string | null } | null, after: { startTime?: string | null }): boolean {
  return !before?.startTime && !!after.startTime
}
